export enum OwnershipType {

  /** Private Corporation */
  privateCorp = 1,

  /** Public Corporation  */
  public = 2,

}
